import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { forkJoin, iif, mergeMap, tap } from 'rxjs';
import { IProfessional } from 'src/app/shared/interfaces/professional/iprofessional';
import { IUnidade } from 'src/app/shared/interfaces/unidade/iunidade';
import { Filter } from 'src/app/shared/models/filter';
import { BankingReportService } from 'src/app/shared/services/banking-report.service';
import { ProfessionalService } from 'src/app/shared/services/professional.service';
import { UnidadeService } from 'src/app/shared/services/unidade.service';
import { UserService } from 'src/app/shared/services/user.service';
import { ModalService } from 'src/app/shared/services/modal.service';
import { WithdrawalModalComponent } from 'src/app/pages/reports/withdraw-modal/withdrawal-modal.component';

@Component({
  selector: 'app-banking-report',
  templateUrl: './banking-report.component.html',
  styleUrls: ['./banking-report.component.scss']
})
export class BankingReportComponent implements OnInit{

  protected datePipe = new DatePipe('pt-BR');
  protected now = new Date();

  protected filter: Filter = new Filter();

  protected currentYear = new Date().getFullYear();
  protected listYear = [
    { name: `Ultimos 12 meses`, id: this.currentYear },
    { name: `${this.currentYear! - 1}`, id: this.currentYear! - 1 },
    { name: `${this.currentYear! - 2}`, id: this.currentYear! - 2 },
    { name: `${this.currentYear! - 3}`, id: this.currentYear! - 3 },
    { name: `${this.currentYear! - 4}`, id: this.currentYear! - 4 },
  ];

   protected listData: any[] = [
      { id: 1, name: new Date() }
  ];

  public activeDateFilter: Date = new Date();

  protected formFilter = this.formBuilder.group({
    year: [this.currentYear],
    account: [null]
  });

  protected unitId = Number(localStorage.getItem('unitId') as string);
  protected userId = Number(localStorage.getItem('userId') as string);

  protected unit!: any;
  protected user!: any;
  protected professional!: any;

  protected taxInfo!: any;
  protected legalName!: any;

  protected issueProfessional: boolean = false;

  protected listMachineOrders: any[] = [];


  protected graphicRevenue: {
    current: number,
    previous: number,
    currentDate: Date,
    labels: any[],
    data: any[]
  } = {
    current: 0,
    previous: 0,
    currentDate: new Date(),
    labels: [],
    data: []
  }


  protected balance: {
    availableAmount: number,
    waitingFundsAmount: number
  } = {
    availableAmount: 0,
    waitingFundsAmount: 0
  }


  protected splitBalance: {
    fee: number,
    amountDebited: number,
    amountCredited: number
  } = {
    fee: 0,
    amountDebited: 0,
    amountCredited: 0
  }

  protected totalRecords: number = 0;

  protected filterMachineOrder: Filter = new Filter().size(10);
  protected loadingMachineOrder: boolean = true;


  constructor(
    private formBuilder: FormBuilder,
    private bankingReportService: BankingReportService,
    private unitService: UnidadeService,
    private userService: UserService,
    private professionalService: ProfessionalService,
    private modalService: ModalService,
  ) {  }

  ngOnInit(): void { 

    this.userService.getbyID(this.userId).pipe(
      tap(res => {
        this.user = res;
        this.issueProfessional = this.user["@type"] == "Professional";
      }),
      mergeMap(res => 
        iif(() => this.issueProfessional, 
        this.professionalService.getById(this.userId),
        this.unitService.getById(this.unitId))
      )
    ).subscribe(res => {
      this.taxInfo = res.taxInfo;
      if(this.taxInfo) {
        this.taxInfo.bankAccount.bank.bankFormat = `${res.taxInfo.bankAccount.bank.code} - ${res.taxInfo.bankAccount.bank.name}`;
      }

      if(this.issueProfessional) {
        this.legalName = (res as IProfessional).company?.legalName
      } else {
        this.legalName = (res as IUnidade)?.legalName;
      }

      this.loadFilterReportRevenue(this.currentYear);
      this.loadReportRevenue();
      this.loadFilterReportMachine(this.activeDateFilter);
      this.loadReportBillingMachine();
      this.loadBalance();
      this.loadBalanceSplit();
    });

    this.formFilter?.get('year')?.valueChanges.subscribe(res => {
      //this.loadFilter();
      this.loadReportRevenue();
      this.loadReportBillingMachine();
    });
  }

  loadFilterReportRevenue(year: number) {
    let before = this.currentYear == year ? this.now : new Date(year, 12, 0);

    let after = new Date(before.getFullYear(), before.getMonth() - 11, 1);

    let beforeFormat = this.datePipe.transform(before, 'yyyy-MM-dd') as string;
    let afterFormat = this.datePipe.transform(after, 'yyyy-MM-dd') as string;

    this.filter.date('date', afterFormat, 'after');
    this.filter.date('date', beforeFormat, 'before');
  }

  loadFilterReportMachine(value: any) {
     let date = new Date(this.verifyFormatDate(value));
    let initDate = new Date(date.getFullYear(), date.getMonth(), 1);
    let endDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    this.filterMachineOrder.date("createdAt", this.datePipe.transform(initDate, "yyyy-MM-dd") as string, 'after');
    this.filterMachineOrder.date("createdAt", this.datePipe.transform(endDate, "yyyy-MM-dd") as string, 'before');
  }



  loadReportRevenue() {
    let filter = this.filter.convertFilterInQuery();

    iif(() => this.issueProfessional,
      this.bankingReportService.getReportRevenueProfessional(filter),
      this.bankingReportService.getReportRevenueClinic(filter))
      .subscribe(res => {
      res.reverse();

      let revenue = {
        gradientColors: ['rgba(0, 160, 0, 1)', 'rgba(255, 255, 255, 0)'],
        data: res.map((obj: any) => obj.value)
      }

      let labels = res.map((obj: any) => this.datePipe.transform(obj.label, 'MM/yyyy') as string);
      this.graphicRevenue = { 
          labels, 
          data: [revenue], 
          currentDate: new Date(res[res.length - 1].label),
          current: res[res.length - 1].value, 
          previous: res[res.length - 2].value, 
        };
    });
  }

  loadReportBillingMachine(contentType: 'application/json' | 'text/csv' = 'application/json') {
    this.loadingMachineOrder = true;
    this.filterMachineOrder.exist('revenuePaymentEvent.revenueEvent.revenueInvoiceEvent');

    if(this.issueProfessional == true) { 
      this.filterMachineOrder.filter('professional', this.userId)
    }

    this.filterMachineOrder.filter('itemsPerPage', 10);
    if(contentType == 'text/csv') {
      this.filterMachineOrder.filter('itemsPerPage', 10000);
      this.filterMachineOrder.filter('page', 1);
    }
    
    let filter = this.filterMachineOrder.convertFilterInQuery(); 
    iif(() => this.issueProfessional,
      this.bankingReportService.getReportBillingMachineProfessional(filter, contentType),
      this.bankingReportService.getReportBillingMachineUnit(filter, contentType))
    .subscribe((res: any) => {
      console.log(res);
        if(contentType != 'text/csv') {
          this.listMachineOrders = res.data;
          this.totalRecords = res.total as number;
        } else {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `relatorio-bancario.csv`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
        this.loadingMachineOrder = false;
    });
  }

  loadBalance() {
    if(this.taxInfo) {
      let recipient = this.taxInfo.recipient;
      this.bankingReportService.getReportBalance(recipient).subscribe((res: any) => {
        this.balance = res;
      })
    }
  }

  loadBalanceSplit() {
    if(this.taxInfo) {
      let recipient = this.taxInfo.recipient;
      this.bankingReportService.getReportSplitBalance(recipient).subscribe((res: any) => {
        this.splitBalance = res;
      });
    }
  }

  onFilterChange($event: any) {
     $event.forEach((filter: any) => {
        if(filter.id == "filterReportRevenue") {
          this.loadFilterReportRevenue(filter.data[0].id);
          this.loadReportRevenue();
        } 
     });
  }

  onFilterChangeMachine($event: any) {
    $event.forEach((filter: any) => {
       if(filter.id == "filterReportMachine") {
          if(filter.filter.length > 0) {
            this.activeDateFilter = filter.filter[0].value as Date;
            this.loadFilterReportMachine(filter.filter[0].value);
            this.loadReportBillingMachine();
        }
      }
     });
  }

  csvReport() {
    this.loadReportBillingMachine('text/csv');
  }

   private verifyFormatDate(date: string): string {
    if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
      return `${date}T00:00:00-03:00`;
    } else {
      return date;
    }
  }

  pageChange(event: any) {
    this.filterMachineOrder.page(event.page);
    this.loadReportBillingMachine();
  }

  loading = false;

  openSaqueModal() {
    this.loading = true;
    
    this.modalService.show(WithdrawalModalComponent, "Solicitar Saque", {
      taxInfo: this.taxInfo,
      splitBalance: this.splitBalance,
      legalName: this.legalName
    });
    
    this.loading = false;
  }
}
